import { formatMoney } from "../utils/formatMoney.js";

export function initProductVariants() {
	const jsonEl = document.getElementById("js-product-variants-json");
	if (!jsonEl) return;

	const variantData = JSON.parse(jsonEl.textContent);
	const variantSelect = document.querySelector("#js-variant-id");
	const optionButtons = document.querySelectorAll(".js-variant-option");

	if (!(optionButtons.length && variantData.length)) return;

	const selectedOptions = [];
	// inizializza selectedOptions con la prima variante nel JSON
	variantData[0].options.forEach((value, index) => {
		selectedOptions[index] = value;
	});

	updateSelectedButtons();

	optionButtons.forEach((button) => {
		button.addEventListener("click", () => {
			const index = parseInt(button.dataset.optionIndex);
			const value = button.dataset.optionValue;

			selectedOptions[index] = value;

			const foundVariant = variantData.find((variant) =>
				variant.options.every((opt, i) => opt === selectedOptions[i])
			);

			if (foundVariant) {
				// Aggiorna il select HIDDEN
				if (variantSelect) {
					variantSelect.value = foundVariant.id;
					// 🔔 Notifica il cambio variante al resto del codice (productForm.js ascolta 'change')
					variantSelect.dispatchEvent(
						new Event("change", { bubbles: true })
					);
				}

				// Aggiorna UI variante
				updatePrice(foundVariant);
				updateMainImage(foundVariant);
				updateAvailability(foundVariant);
				updateAddToCartButton(foundVariant);
			}

			updateSelectedButtons();
		});
	});

	function updateSelectedButtons() {
		optionButtons.forEach((btn) => {
			const index = parseInt(btn.dataset.optionIndex);
			const value = btn.dataset.optionValue;
			if (selectedOptions[index] === value) {
				btn.classList.add("bg-primary", "text-white");
			} else {
				btn.classList.remove("bg-primary", "text-white");
			}
		});
	}

	function updatePrice(variant) {
		const priceContainer = document.querySelector(".js-product-price");
		if (!priceContainer) return;

		let html = "";
		if (variant.compare_at_price > variant.price) {
			const discountAmount = variant.compare_at_price - variant.price;
			const discountPercentage = Math.floor(
				(discountAmount / variant.compare_at_price) * 100
			);
			html = `
        <div class="flex space-x-6 items-start text-sm">
          <div class="pr-6 border-r border-secondary">
            <p class="text-accent">Prezzo scontato <strong>−${discountPercentage}%</strong></p>
            <p class="text-accent text-xl font-bold">${formatMoney(
				variant.price
			)}</p>
          </div>
          <div class="pr-6 border-r border-secondary">
            <p>Prezzo di listino</p>
            <p class="line-through text-xl">${formatMoney(
				variant.compare_at_price
			)}</p>
          </div>
          <div>
            <p>Risparmio</p>
            <p class="text-xl font-bold">${formatMoney(discountAmount)}</p>
          </div>
        </div>`;
		} else {
			html = `<div class="text-primary text-xl font-bold">${formatMoney(
				variant.price
			)}</div>`;
		}
		priceContainer.innerHTML = html;
	}

	function updateMainImage(variant) {
		const imgWrapper = document.querySelector(".js-product-main-image");
		const imgEl = imgWrapper?.querySelector("img");
		const loader = imgWrapper?.parentElement.querySelector(
			".js-product-gallery-loader"
		);
		if (!imgEl) return;

		loader?.classList.remove("hidden");
		if (!imgEl.dataset.defaultSrc) imgEl.dataset.defaultSrc = imgEl.src;
		const newSrc = variant.featured_image?.src || imgEl.dataset.defaultSrc;

		const tempImg = new Image();
		tempImg.src = newSrc;

		tempImg.onload = () => {
			imgEl.addEventListener(
				"load",
				() => {
					loader?.classList.add("hidden");
				},
				{ once: true }
			);
			imgEl.src = newSrc;
			imgEl.srcset = newSrc;
		};
		tempImg.onerror = () => {
			imgEl.src = imgEl.dataset.defaultSrc;
			imgEl.srcset = imgEl.dataset.defaultSrc;
			loader?.classList.add("hidden");
		};
	}

	function updateAvailability(variant) {
		const availabilityContainer =
			document.querySelector(".js-availability");
		if (!availabilityContainer) return;

		const optionEl = document.querySelector(
			`#js-variant-id option[value="${variant.id}"]`
		);
		if (!optionEl) return;

		const inventoryQuantity = parseInt(optionEl.dataset.inventory);
		const inventoryManagement = optionEl.dataset.inventoryManagement;

		if (variant.available) {
			if (inventoryManagement && inventoryQuantity > 0) {
				availabilityContainer.innerHTML = `<span class="text-primary font-bold">(${inventoryQuantity} disponibili)</span>`;
			} else {
				availabilityContainer.innerHTML = `<span class="text-primary font-bold">Disponibile</span>`;
			}
		} else {
			availabilityContainer.innerHTML = `<span class="text-accent font-bold">Esaurito</span>`;
		}
	}

	function updateAddToCartButton(variant) {
		const addToCartBtn = document.querySelector(
			"#js-product-form-ajax button[type='submit']"
		);
		if (!addToCartBtn) return;
		if (variant.available) {
			addToCartBtn.disabled = false;
			addToCartBtn.classList.remove("button-not-allowed");
		} else {
			addToCartBtn.disabled = true;
			addToCartBtn.classList.add("button-not-allowed");
		}
	}
}
